export const generatePublicUrl = (fileName) => {
  return `https://dev.mentorx4u.com/public/${fileName}`;
};
